import React from 'react'

// components
import GroupDropdown from '../components/GroupDropdown'
import CarDropdown from '../components/CarDropdown'
// import PenaltyDropdown from '../components/PenaltyDropdown'
import ResetFiltersButton from '../components/ResetFiltersButton'
import FilterTable from '../components/FilterTable'
import { ButtonToolbar, Container, Header, Content } from 'rsuite';
import ScatterChart from '../components/ScatterChart'
import { useSelector } from 'react-redux';
import { getContextOptions, getOptions, getYou } from '../redux/options/selectors';

// home page
const HomePage = ( { context = 'homepage' } ) => {
  
  // set column options
  const column_options = { pos: true } 

  const { car  } = getContextOptions( useSelector( getOptions ), context )
  const you = useSelector( getYou )
  const className = car * 1 === you * 1 ? 'your-car' : ''

  return (
    <Container className={ context }>
      <Header>
        <ButtonToolbar className="filters">
          <GroupDropdown context={ context }/>
          <CarDropdown context={ context }/>
          { /* <PenaltyDropdown context={ context }/> */ }
          <ResetFiltersButton context={ context }/>   
        </ButtonToolbar>
      </Header>
      <Content>        
        <FilterTable 
          context={ context } 
          column_options={ column_options }
          className={ className }
          between={ <ScatterChart/> }
        />
      </Content>
    </Container>
  )
}

export default HomePage